import { Button, TextField, TextareaAutosize } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { cleanDomain, generateSlug, isValidDomain } from '../../../helpers/randoms';
import { useDispatch, useSelector } from 'react-redux';
import { updateWebsite } from '../../redux/slices/websiteSlice';
import axios from 'axios';
import { MessageContext } from '../../contexts/MessageContext';
import InternalTemplate from "../../templates/Internal";
import DashboardSideBarMenu from "./SidebarMenu";

const ParkDomain = ({ data = {}, websiteId, onUpdate }) => {
  console.log('in page form: new',data);
  //const [slugEditedManually, setSlugEditedManually] = useState(false);
  const [websiteData, setWebsiteData] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [haveDomain, setHaveDomain] = useState(false);
  const [purchaseDomain, setPurchaseDomain] = useState(false);

  const [searchingDomain, setSearchingDomain] = useState(false);
  const [attachingDomain, setAttachingDomain] = useState(false);

  const [domains, setDomains] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState('');
  const [error, setError] = useState(null);

  const dispatch = useDispatch();
  const { addMessage } = useContext(MessageContext);
  
  const currentEditedWebsitePageId = useSelector(state => state.websites.currentEditedWebsitePageId);
  const theWbsiteData = useSelector(state => state.websites.websites.find(website => website.id === parseInt(websiteId)));

  const handleSearch = () => {
    // Replace with your API endpoint
    const apiUrl = `https://sanmayadhal.com/domains?name=${searchingDomain}`;

    fetch(apiUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        setDomains(data.data.domains);
      })
      .catch((error) => {
        setError(error.toString());
      });
  };

  const handleDomainSelect = (domain) => {
    //setSelectedDomain(domain);
  };

  const handleLinkClick = () => {
    if (selectedDomain) {
      // Handle navigation or other actions with the selected domain
      //window.location.href = `http://${selectedDomain}`;
    }
  };


  const handleSave = async() => {      
      if(!websiteId){
        addMessage('Some issue occured, report us.');
        return;
      }
      if(!attachingDomain){
        addMessage('Please enter a domain.');
        return;
      }
      if (!isValidDomain(attachingDomain)) {
        addMessage('Please enter a valid domain.');
        return;
      }
      const cleanedDomain = cleanDomain(attachingDomain);
      setIsLoading(true);
      addMessage('');
      try {
        const response = await axios.post('https://bvorqhdsibaukalonivs.supabase.co/functions/v1/add-domain-to-website/add-domain', { domain: cleanedDomain }, {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_KEY}`,
          },
        });
  
        console.log(response.data.message);
      } catch (error) {
        console.log(`Error: ${error.response ? error.response.data.error : error.message}`);
      } finally {
        dispatch(updateWebsite({id: websiteId, data: {domain: cleanedDomain}}))
        setIsLoading(false);
        addMessage(`Your domain added. If your CNAME record points correctly, it'll take few minutes to appear on your domain`)
      }
  }

  useEffect(() => {
    setWebsiteData(theWbsiteData)
  }, [theWbsiteData]);

  const headerContent = '';
  const footerContent = '';
  const leftSideBarContent = <DashboardSideBarMenu />;

  return (
    <InternalTemplate headerContent={headerContent} footerContent={footerContent} leftSideBarContent={leftSideBarContent}>
      <div className='col-md-5 mx-auto p-5'>
        {/*<StripeComponent />*/}
        {websiteData && websiteData.domain && <h6>Website: <a target='_blank' href={`https://${websiteData.domain}`}>{websiteData.domain}</a></h6>}
        {!haveDomain && !purchaseDomain && 
          <>
            <Button variant='outlined' color='secondary' onClick={() => {setPurchaseDomain(false); setHaveDomain(true)}}>I have a domain</Button>
            <Button variant='outlined' color='secondary' onClick={() => {setHaveDomain(false); setPurchaseDomain(true)}}>Purchase a domain</Button>
          </>
        }
        {haveDomain &&
          <>
            <h2>Park a domain</h2>
            <label>
              <TextField 
                variant="outlined"
                fullWidth 
                style={{ marginTop: 11 }}
                label={'Domain Name'}
                value={attachingDomain? attachingDomain : (websiteData) ? websiteData.domain: ''}
                onChange={(e) => setAttachingDomain(e.target.value)}
              />
            </label>
            
            <label>
              <TextField 
                variant="outlined"
                fullWidth 
                style={{ marginTop: 11 }}
                label={'Domain Name'}
                value={attachingDomain? attachingDomain : (websiteData) ? websiteData.domain: ''}
                onChange={(e) => setAttachingDomain(e.target.value)}
              />
            </label>
            <div>
              <div>Once you provide, set the CNAME record to: <br /><b>{websiteData && websiteData.staging_domain}</b></div>
              {websiteData && websiteData.domain && <>The current website URL is <a target='_blank' href={`https://${websiteData.domain}`}>{websiteData.domain}</a></>}
              {/*Records: 
              <ol>
                <li>
                  
                </li>
              </ol>*/}
            </div>
            <br />
            <Button onClick={handleSave} fullWidth className='my-3' variant='outlined' color='primary' disabledi={(attachingDomain) ? true: false}>Connect it</Button>
          </>
        }
        {purchaseDomain &&
          <>
            <h2>Purchase a new domain</h2>
            <label>
              <TextField 
                variant="outlined"
                fullWidth 
                style={{ marginTop: 11 }}
                label={'Domain Name'}
                value={searchingDomain}
                onChange={(e) => setSearchingDomain(e.target.value)}
              />
            </label>
            <div>
              <h1>Select a Domain</h1>
              {error ? (
                <p>Error fetching domains: {error}</p>
              ) : (
                <>
                  <span>
                    {domains && domains.map((domain) => (
                      <div key={domain} className='border-bottom py-3 pointer row d-flex' onClick={handleDomainSelect(domain.domain)}>
                        <div className='col'>
                            {domain.domain}
                        </div>
                        <div className='col-md-4 text-end'>
                            {domain.available && <Button onClick={handleSearch} className='my-3' variant='contained' color='primary'>Buy $9</Button>}
                        </div>
                      </div>
                    ))}
                  </span>
                  <button onClick={handleLinkClick} disabled={!selectedDomain}>
                    Go to Website
                  </button>
                </>
              )}
            </div>
            <br />
            <Button onClick={handleSearch} fullWidth className='my-3' variant='outlined' color='primary'>Search the domain</Button>
          </>
        }
        <div className='py-5'>        
          {!haveDomain && purchaseDomain && 
            <>
              <Button variant='outlined' color='secondary' onClick={() => {setPurchaseDomain(false); setHaveDomain(true)}}>I have a domain</Button>
            </>
          }       
          {haveDomain && !purchaseDomain && 
            <>
              <Button variant='outlined' color='secondary' onClick={() => {setHaveDomain(false); setPurchaseDomain(true)}}>Purchase a domain</Button>
            </>
          }
        </div>
      </div>
    </InternalTemplate>
  );
};

export default ParkDomain;
